// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.tvp-pointer-events-none {
  pointer-events: none;
}
.tvp-absolute {
  position: absolute;
}
.tvp-relative {
  position: relative;
}
.-tvp-bottom-1\\/2 {
  bottom: -50%;
}
.-tvp-top-6 {
  top: -24px;
}
.tvp-left-1\\/2 {
  left: 50%;
}
.tvp-right-1\\/2 {
  right: 50%;
}
.tvp-right-2 {
  right: 8px;
}
.tvp-top-1\\/2 {
  top: 50%;
}
.tvp-m-0 {
  margin: 0px;
}
.tvp-m-1 {
  margin: 4px;
}
.tvp-m-2 {
  margin: 8px;
}
.tvp-m-auto {
  margin: auto;
}
.tvp-mx-4 {
  margin-left: 16px;
  margin-right: 16px;
}
.tvp-mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.tvp-my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
.tvp-my-2 {
  margin-top: 8px;
  margin-bottom: 8px;
}
.tvp-my-3 {
  margin-top: 12px;
  margin-bottom: 12px;
}
.tvp-my-4 {
  margin-top: 16px;
  margin-bottom: 16px;
}
.tvp-my-5 {
  margin-top: 20px;
  margin-bottom: 20px;
}
.tvp-my-8 {
  margin-top: 32px;
  margin-bottom: 32px;
}
.tvp-my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.tvp-mb-1 {
  margin-bottom: 4px;
}
.tvp-mb-10 {
  margin-bottom: 40px;
}
.tvp-mb-2 {
  margin-bottom: 8px;
}
.tvp-mb-2\\.5 {
  margin-bottom: 10px;
}
.tvp-mb-3 {
  margin-bottom: 12px;
}
.tvp-mb-4 {
  margin-bottom: 16px;
}
.tvp-mb-9 {
  margin-bottom: 36px;
}
.tvp-mb-\\[60px\\] {
  margin-bottom: 60px;
}
.tvp-mb-auto {
  margin-bottom: auto;
}
.tvp-ml-1 {
  margin-left: 4px;
}
.tvp-ml-2 {
  margin-left: 8px;
}
.tvp-ml-2\\.5 {
  margin-left: 10px;
}
.tvp-ml-auto {
  margin-left: auto;
}
.tvp-mr-2 {
  margin-right: 8px;
}
.tvp-mr-2\\.5 {
  margin-right: 10px;
}
.tvp-mr-4 {
  margin-right: 16px;
}
.tvp-mr-auto {
  margin-right: auto;
}
.tvp-mt-1 {
  margin-top: 4px;
}
.tvp-mt-1\\.5 {
  margin-top: 6px;
}
.tvp-mt-10 {
  margin-top: 40px;
}
.tvp-mt-12 {
  margin-top: 48px;
}
.tvp-mt-2 {
  margin-top: 8px;
}
.tvp-mt-3 {
  margin-top: 12px;
}
.tvp-mt-4 {
  margin-top: 16px;
}
.tvp-mt-5 {
  margin-top: 20px;
}
.tvp-mt-7 {
  margin-top: 28px;
}
.tvp-mt-8 {
  margin-top: 32px;
}
.tvp-mt-9 {
  margin-top: 36px;
}
.tvp-mt-auto {
  margin-top: auto;
}
.tvp-box-border {
  box-sizing: border-box;
}
.tvp-flex {
  display: flex;
}
.tvp-h-12 {
  height: 48px;
}
.tvp-h-3 {
  height: 12px;
}
.tvp-h-4\\/5 {
  height: 80%;
}
.tvp-h-40 {
  height: 160px;
}
.tvp-h-52 {
  height: 208px;
}
.tvp-h-6 {
  height: 24px;
}
.tvp-h-7 {
  height: 28px;
}
.tvp-h-\\[116px\\] {
  height: 116px;
}
.tvp-h-auto {
  height: auto;
}
.tvp-h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
.tvp-max-h-96 {
  max-height: 384px;
}
.tvp-w-10\\/12 {
  width: 83.333333%;
}
.tvp-w-11\\/12 {
  width: 91.666667%;
}
.tvp-w-12 {
  width: 48px;
}
.tvp-w-14 {
  width: 56px;
}
.tvp-w-20 {
  width: 80px;
}
.tvp-w-24 {
  width: 96px;
}
.tvp-w-3 {
  width: 12px;
}
.tvp-w-5\\/6 {
  width: 83.333333%;
}
.tvp-w-6 {
  width: 24px;
}
.tvp-w-7 {
  width: 28px;
}
.tvp-w-\\[116px\\] {
  width: 116px;
}
.tvp-w-\\[185px\\] {
  width: 185px;
}
.tvp-w-\\[350px\\] {
  width: 350px;
}
.tvp-w-\\[420px\\] {
  width: 420px;
}
.tvp-w-\\[60\\%\\] {
  width: 60%;
}
.tvp-w-auto {
  width: auto;
}
.tvp-w-full {
  width: 100%;
}
.tvp-max-w-2xl {
  max-width: 42rem;
}
.tvp-max-w-\\[1\\.625rem\\] {
  max-width: 1.625rem;
}
.tvp-max-w-\\[400px\\] {
  max-width: 400px;
}
.tvp-max-w-fill-available {
  max-width: -webkit-fill-available;
}
.tvp-max-w-lg {
  max-width: 32rem;
}
.tvp-max-w-max {
  max-width: -moz-max-content;
  max-width: max-content;
}
.tvp-flex-auto {
  flex: 1 1 auto;
}
.tvp-flex-grow {
  flex-grow: 1;
}
.-tvp-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-tvp-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tvp-cursor-none {
  cursor: none;
}
.tvp-cursor-not-allowed {
  cursor: not-allowed;
}
.tvp-cursor-pointer {
  cursor: pointer;
}
.tvp-list-disc {
  list-style-type: disc;
}
.tvp-flex-row {
  flex-direction: row;
}
.tvp-flex-col {
  flex-direction: column;
}
.tvp-items-center {
  align-items: center;
}
.tvp-justify-start {
  justify-content: flex-start;
}
.tvp-justify-center {
  justify-content: center;
}
.tvp-justify-between {
  justify-content: space-between;
}
.tvp-justify-around {
  justify-content: space-around;
}
.tvp-gap-1 {
  gap: 4px;
}
.tvp-gap-2 {
  gap: 8px;
}
.tvp-gap-3 {
  gap: 12px;
}
.tvp-gap-4 {
  gap: 16px;
}
.tvp-overflow-hidden {
  overflow: hidden;
}
.tvp-overflow-y-auto {
  overflow-y: auto;
}
.tvp-overflow-x-hidden {
  overflow-x: hidden;
}
.tvp-text-ellipsis {
  text-overflow: ellipsis;
}
.tvp-whitespace-nowrap {
  white-space: nowrap;
}
.tvp-rounded {
  border-radius: 4px;
}
.tvp-rounded-full {
  border-radius: 9999px;
}
.tvp-rounded-lg {
  border-radius: 8px;
}
.tvp-rounded-md {
  border-radius: 6px;
}
.tvp-border-1\\.5 {
  border-width: 1.5px;
}
.tvp-border-2 {
  border-width: 2px;
}
.tvp-border-solid {
  border-style: solid;
}
.tvp-border-none {
  border-style: none;
}
.tvp-border-slate {
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity));
}
.tvp-bg-blue-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity));
}
.tvp-bg-gray-light {
  --tw-bg-opacity: 1;
  background-color: rgb(211 220 230 / var(--tw-bg-opacity));
}
.tvp-bg-green {
  --tw-bg-opacity: 1;
  background-color: rgb(19 206 102 / var(--tw-bg-opacity));
}
.tvp-bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.tvp-p-1 {
  padding: 4px;
}
.tvp-p-3 {
  padding: 12px;
}
.tvp-p-4 {
  padding: 16px;
}
.tvp-px-2 {
  padding-left: 8px;
  padding-right: 8px;
}
.tvp-px-2\\.5 {
  padding-left: 10px;
  padding-right: 10px;
}
.tvp-px-32 {
  padding-left: 128px;
  padding-right: 128px;
}
.tvp-px-4 {
  padding-left: 16px;
  padding-right: 16px;
}
.tvp-px-5 {
  padding-left: 20px;
  padding-right: 20px;
}
.tvp-px-8 {
  padding-left: 32px;
  padding-right: 32px;
}
.tvp-py-1 {
  padding-top: 4px;
  padding-bottom: 4px;
}
.tvp-py-2 {
  padding-top: 8px;
  padding-bottom: 8px;
}
.tvp-py-2\\.5 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.tvp-py-28 {
  padding-top: 112px;
  padding-bottom: 112px;
}
.tvp-py-4 {
  padding-top: 16px;
  padding-bottom: 16px;
}
.tvp-pr-1 {
  padding-right: 4px;
}
.tvp-pr-2 {
  padding-right: 8px;
}
.tvp-pr-4 {
  padding-right: 16px;
}
.tvp-pr-6 {
  padding-right: 24px;
}
.tvp-pt-\\[60px\\] {
  padding-top: 60px;
}
.tvp-text-center {
  text-align: center;
}
.tvp-align-middle {
  vertical-align: middle;
}
.tvp-text-base {
  font-size: 16px;
  line-height: 24px;
}
.tvp-text-lg {
  font-size: 18px;
  line-height: 28px;
}
.tvp-text-sm {
  font-size: 14px;
  line-height: 20px;
}
.tvp-text-xl {
  font-size: 20px;
  line-height: 28px;
}
.tvp-text-xs {
  font-size: 12px;
  line-height: 16px;
}
.tvp-font-bold {
  font-weight: 700;
}
.tvp-font-medium {
  font-weight: 500;
}
.tvp-font-semibold {
  font-weight: 600;
}
.tvp-uppercase {
  text-transform: uppercase;
}
.tvp-leading-6 {
  line-height: 24px;
}
.tvp-text-\\[\\#4a4a4a\\] {
  --tw-text-opacity: 1;
  color: rgb(74 74 74 / var(--tw-text-opacity));
}
.tvp-text-orange {
  --tw-text-opacity: 1;
  color: rgb(255 120 73 / var(--tw-text-opacity));
}
.tvp-text-slate {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
.tvp-text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.tvp-shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tvp-max-w-fill-available {
  max-width: -webkit-fill-available;
}

:root {
  --neutral-color: #4a4a4a;
  --anchor-color: #1d4ed8;
}

#proview_root {
  background: #008000;
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  max-height: 100vh;
  min-height: 100vh;
  position: fixed;
  top: 0;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 101;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
}
#proview_root #logo-container {
  position: absolute;
  top: 0;
  left: 116px;
  width: 115px;
  height: 81px;
  background-color: #fff;
  justify-content: center;
  align-items: center;
  padding: 13px 15px;
  box-sizing: border-box;
  border-radius: 0px 0px 8px 8px;
}

#logo-container #brand-logo {
  max-width: 100%;
  max-height: 100%;
}
/* Move to Theme */
#proview_root .tvp-clr-white {
  color: #fff;
}
#proview_root .tvp-clr-neutral {
  color: var(--neutral-color);
}
#proview_root .tvp-clr-red {
  color: #b91c1c;
}
#proview_root .tvp-brand-color {
  color: var(--brand-color);
}
#proview_root .tvp-clr-green {
  color: #1cb841;
}

#proview_root .tvp-clr-dgray {
  color: #333;
}

#proview_root .tvp-bg-black {
  background-color: #000 !important;
}

#proview_root .tvp-bg-white {
  background-color: #fff;
}

#proview_root .tvp-bg-green {
  background-color: var(--brand-color);
}
#proview_root .tvp-bg-red {
  background-color: #d7554e;
}

#proview_root .tvp-bg-lgray {
  background-color: #bdbdbd;
  cursor: unset;
}

#proview_root .tvp-bg-lgray-500 {
  background-color: #f7f0f0;
}

#proview_root .tvp-bdr-green {
  border-color: var(--brand-color);
}

#proview_root .tvp-bdr-red {
  border-color: #d7554e;
}

#proview_root .tvp-bdr-lgray {
  border-color: #bdbdbd;
}

/* Customize classes */
#proview_root .tvp-my-h-12 {
  height: 48px;
}

#proview_root .tvp-base {
  width: 96%;
  max-height: 520px;
  min-height: 520px;
  border-top: 10px solid var(--brand-color);
  min-width: 680px;
}

#proview_root .tvp-base .tvp-squre-25 {
  width: 23px;
  height: 23px;
}

#proview_root .tvp-base .tvp-DemoWrapper {
  margin: -10px -15px;
}

#proview_root .tvp-base a:hover,
#proview_root .tvp-base .tvp-link:hover {
  color: #053a11 !important;
  text-decoration: underline;
  cursor: pointer;
}

#proview_root .tvp-base h2 {
  font-size: 20px;
}

#proview_root .tvp-base h6 {
  font-size: 18px;
}

#proview_root .tvp-base a,
#proview_root .tvp-base .tvp-link {
  color: var(--anchor-color) !important;
  margin: 0px 5px;
}

#proview_root .tvp-base .tvp-miniLoader {
  width: 40px;
  height: 40px;
  margin: auto;
}

#proview_root .tvp-base .tvp-screenShareIcon {
  width: 220px;
}

#proview_root .tvp-base .tvp-iconHolder {
  width: 35px;
  cursor: pointer;
  height: 35px;
  background-color: #2dd4bf;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 15px;
}

#proview_root .tvp-base li {
  position: relative;
  min-height: 33px;
  display: flex;
}

#proview_root .tvp-base .tvp-content {
  align-items: center;
}

#proview_root .tvp-base .tvp-GlobeIcon {
  display: block;
  color: var(--neutral-color);
}

#proview_root .tvp-base .tvp-min-w-unset {
  min-width: unset !important;
}

#proview_root .tvp-base .tvp-custom-file-input::-webkit-file-upload-button {
  visibility: hidden;
  z-index: 100;
  width: 55%;
}

#proview_root #file_input {
  min-height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 3px;
  max-width: 95px;
  margin: auto;
}

#proview_root .tvp-base .tvp-custom-file-input::before {
  content: "Select Image";
  display: inline-block;
  background: linear-gradient(to bottom, #f9f9f9, #e3e3e3);
  border: 2px solid #1cb841 !important;
  border-radius: 3px;
  padding: 5px 8px;
  outline: none;
  white-space: nowrap;
  cursor: pointer;
  text-shadow: 1px 1px #fff;
  font-weight: 700;
  font-size: 10pt;
  overflow: hidden;
  z-index: 2;
  height: 31px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}

/* Make label as display flex as important since conflicting with oliver styles */
#proview_root .tvp-conditons label {
  display: flex !important;
}

#proview_root .tvp-base .tvp-custom-file-input {
  width: 60%;
  overflow: hidden;
  height: 33px;
}

#proview_root .tvp-base .tvp-custom-file-input:hover::before {
  border-color: #000;
}

#proview_root .tvp-base .tvp-custom-file-input:active::before {
  background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
}

#proview_root .tvp-base .tvp-custom-file-input::before {
  border-color: #000;
  z-index: 11;
}

#proview_root .tvp-base .tvp-envCheckRecordingComplete {
  width: 200px;
  margin: 0 auto;
  height: 150px;
  background: #4a4a4a !important;
  text-align: center;
  line-height: 150px;
  position: relative;
}

#proview_root .tvp-base .tvp-permissionIcon {
  width: 130px;
}

#proview_root .tvp-base .tvp-IdPreview {
  width: 200px;
  height: 150px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
}

#proview_root .tvp-base .tvp-w-55 {
  width: 55%;
}

#proview_root .tvp-base .tvp-SmileyLogo {
  width: 60%;
  animation: wiggle 2s linear;
}

#proview_root .tvp-base .tvp-innerContent {
  width: inherit;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

#proview_root .tvp-base .tvp-photo-verification-page {
  width: 45%;
  text-align: center;
  min-height: 200px;
  height: 100%;
}

#proview_root .tvp-base .tvp-progressBarWrapper {
  max-width: 400px;
  width: 80vw;
  background-color: #e0e0e0;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px inset;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
}

#proview_root .tvp-base .tvp-progressBar {
  height: 20px;
  background: linear-gradient(270deg, #eee 0%, #4caf50 9.31%, #4caf50 100%);
  transition: width 0.6s ease;
}

#proview_root .tvp-base .tvp-or1-2 {
  order: 1;
}

#proview_root .tvp-base .tvp-or2-1 {
  order: 2;
  margin-left: auto;
  margin-right: auto;
}

#proview_root .tvp-base .tvp-phto-text-folder {
  max-height: 65px;
  min-height: 65px;
}

#proview_root .tvp-base .tvp-divider-identity {
  position: relative;
  width: 4px;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: visible;
  background-color: var(--brand-color);
}

#proview_root .tvp-base .tvp-dividerText-identity {
  z-index: 999;
  padding: 5px;
  background-color: #fff;
}

#proview_root .tvp-base .tvp-mt-15 {
  margin-top: 58px;
}

#proview_root .tvp-base .tvp-dropdown {
  cursor: pointer;
  max-width: 12em;
  background: #fff;
  color: rgba(0, 0, 0, 0.87);
  border: 1px solid #bdbdbd;
  border-radius: 5px !important;
  padding: 5px;
  font-size: 0.95em;
  height: 34px;
  text-overflow: ellipsis;
  clear: both;
}

#proview_root .tvp-base .tvp-tips {
  color: var(--neutral-color);
  font-weight: 700;
}

#proview_root .tvp-base .tvp-videoPlayerWrapper {
  width: -moz-fit-content;
  width: fit-content;
  height: 180px;
}

#proview_root .tvp-base .tvp-photIdVideoPlayerWrapper {
  width: -moz-fit-content;
  width: fit-content;
  height: 150px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  display: flex;
  justify-content: center;
}

#proview_root .tvp-base .tvp-photoIdCanvas {
  position: absolute;
  top: 0;
  /* left: 0; */
}

#proview_root .tvp-base .tvp-audioTest {
  font-weight: normal;
  text-transform: uppercase;
  margin-bottom: 20px;
  font-size: 0.8em;
  color: var(--neutral-color);
}

#proview_root .tvp-base .tvp-testEnvDemoVideo {
  width: 265px;
  height: auto;
  -o-object-fit: contain !important;
     object-fit: contain !important;
  margin: 0 auto;
  border: 1px solid #ccc;
}

#proview_root .tvp-base .tvp-videoText {
  min-width: 200px;
  display: flex;
  justify-content: center;
  font-size: 14px;
  align-items: center;
  height: 33px;
}

#proview_root .tvp-base .tvp-parts {
  width: 96%;
  display: flex;
  align-items: center;
  padding: 5px 0px;
  margin: 0px auto;
}

#proview_root .tvp-base .tvp-w-150 {
  width: 150px !important;
}

#proview_root .tvp-base .tvp-min-w-150 {
  min-width: 150px;
}

#proview_root .tvp-base .tvp-buttonPart {
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  margin: auto;
  flex-direction: row;
}

#proview_root .tvp-base li {
  padding: 5px;
  display: flex;
}

#proview_root .tvp-base .tvp-recorderContainer {
  position: absolute;
  bottom: 17px;
  left: 17px;
  display: flex;
  align-items: center;
}

#proview_root .tvp-base .tvp-screenShareIcon {
  width: 228px;
  height: 189px;
  margin-left: auto;
  margin-right: auto;
}

#proview_root .tvp-connectingIcon {
  width: 120px;
  height: 80px;
}

#proview_root .tvp-text-xs {
  font-size: 12px !important;
}

#proview_root .tvp-proctoring_fc_frame {
  margin-bottom: 100px;
  z-index: 9999999 !important;
  margin-right: 15px;
}

#proview_root .tvp-seccam-main {
  width: 50%;
  min-height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 280px;
  box-sizing: border-box;
}

#proview_root .tvp-seccam-Wrapper {
  position: relative;
  width: 100%;
  min-height: 100%;
  height: auto;
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  flex-wrap: wrap;
  overflow-y: auto;
}

#proview_root .tvp-demoBtn {
  margin-right: 15px;
}

#proview_root #basediv {
  background-color: #000;
  min-width: 100vw;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  max-height: 100vh;
}

#tvp_recorder_container {
  position: relative;
  z-index: 9999999;
  width: 100%;
  height: 100%;
  display: flex;
}

#tvp_recorder_container_minimize_btn {
  position: absolute;
  z-index: 99999999;
  cursor: pointer;
  top: -10px;
  right: -10px;
  padding: 2px;
  background-color: dodgerblue;
  color: white;
  width: 16px;
  height: 16px;
  display: grid;
  place-items: center;
  border: none;
  border-radius: 50%;
  pointer-events: auto;
}

#recorder_video_custom,
#tvp_recorder_container {
  z-index: 9999999;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 15.625vh;
  height: 10.416vh;
}

#tvp_recorder_container > video,
#tvp_recorder_container > canvas {
  width: 15.625vh;
  height: 10.416vh;
}

#tvp_recorder_container > video {
  z-index: 300;
  border: 3px solid #000;
  border-radius: 6px;
  background-color: #fff;
}

#tvp_recorder_container > canvas {
  z-index: 400;
}

@media only screen and (max-width: 680px) {
  #proview_root .tvp-base {
    max-width: 94vw !important;
    min-width: 94vw !important;
    margin: auto !important;
    margin: 2%;
  }

  #proview_root .tvp-my-h-12 {
    height: auto !important;
  }

  #proview_root .tvp-base .tvp-phto-text-folder {
    max-height: unset;
    height: auto;
  }

  #proview_root .tvp-base .tvp-buttonPart {
    width: 100%;
    flex-direction: column;
    justify-content: space-between;
  }
}

@media only screen and (max-width: 480px) {
  #proview_root .tvp-base {
    min-width: 94vw !important;
    margin: auto !important;
  }

  #proview_root .tvp-base .tvp-app {
    width: 98vw;
  }

  #proview_root .tvp-base .tvp-or1-2 {
    order: 2;
  }

  #proview_root .tvp-base .tvp-videoText {
    flex-direction: column;
  }

  #proview_root .tvp-base .tvp-or2-1 {
    order: 1;
  }

  #proview_root .tvp-base .tvp-col-row {
    display: flex;
    flex-direction: column;
  }

  #proview_root .tvp-base .tvp-col-row > div {
    width: 100% !important;
  }

  #proview_root .tvp-base .tvp-divider-identity {
    position: relative;
    width: 100%;
    height: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: visible;
    background-color: var(--brand-color);
    margin-top: 7px;
    margin-bottom: 7px;
  }

  #proview_root .tvp-base .tvp-progressBarWrapper {
    max-width: 80%;
  }

  #proview_root .tvp-base .tvp-GlobeIcon {
    display: none;
  }

  #proview_root .tvp-base .tvp-w-55 {
    width: 100%;
  }
}

@keyframes wiggle {
  0%,
  3% {
    transform: rotateZ(0);
  }

  5% {
    transform: rotateZ(-15deg);
  }

  10% {
    transform: rotateZ(15deg);
  }

  16% {
    transform: rotateZ(-12deg);
  }

  23% {
    transform: rotateZ(12deg);
  }

  31% {
    transform: rotateZ(-9deg);
  }

  40% {
    transform: rotateZ(9deg);
  }

  50% {
    transform: rotateZ(-6deg);
  }

  61% {
    transform: rotateZ(6deg);
  }

  73% {
    transform: rotateZ(-3deg);
  }

  87% {
    transform: rotateZ(3deg);
  }

  97%,
  100% {
    transform: rotateZ(0);
  }
}

.tvp-proview_root #tvp_recorder_holder .tvp-linkModel {
  z-index: 1;
  bottom: 40px;
  left: 10px;
  width: auto;
  height: -moz-fit-content;
  height: fit-content;
  border: 1px solid #fff;
  border-radius: 10px;
  background-color: #f8fafc;
  color: #1d4ed8;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15), 0px 0px 5px 0px rgba(0, 0, 0, 0.3);
}

.tvp-proview_root #tvp_recorder_holder .tvp-modalPosition {
  left: 20px !important;
  bottom: 32px !important;
}

.tvp-proview_root #tvp_recorder_holder .tvp-alignCenter {
  align-items: center;
}

.tvp-proview_root #Dragablediv {
  display: none;
}

.tvp-proview_root .tvp-button-no-border {
  all: unset;
  cursor: pointer;
  border: none;
  display: flex;
  box-shadow: none;
}

.tvp-proview_root button.tvp-button-no-border:focus,
.tvp-proview_root button.tvp-button-no-border:focus::before {
  all: unset;
  cursor: pointer;
  border: none;
  display: flex;
  box-shadow: none;
}

/* #proview_root > div:nth-child(2){
  display: none;
} */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf;wEACsE;EACtE,mCAAmC;EACnC,kCAAkC;EAClC,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,MAAM;EACN,WAAW;EACX,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA,kBAAkB;AAClB;EACE,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,wDAAwD;EACxD,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,iFAAiF;AACjF;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yEAAyE;EACzE,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iCAA8B;KAA9B,8BAA8B;EAC9B,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,oCAAoC;IACpC,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;AA8JA;EACE;;IAEE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,qBAAqB;EACvB;AACF;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,UAAU;EACV,WAAW;EACX,wBAAmB;EAAnB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,oFAAoF;AACtF;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;;GAEG","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root {\n  --neutral-color: #4a4a4a;\n  --anchor-color: #1d4ed8;\n}\n\n#proview_root {\n  background: #008000;\n  font-size: 14px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\",\n    \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  margin: 0;\n  max-height: 100vh;\n  min-height: 100vh;\n  position: fixed;\n  top: 0;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  z-index: 101;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: auto;\n}\n#proview_root #logo-container {\n  position: absolute;\n  top: 0;\n  left: 116px;\n  width: 115px;\n  height: 81px;\n  background-color: #fff;\n  justify-content: center;\n  align-items: center;\n  padding: 13px 15px;\n  box-sizing: border-box;\n  border-radius: 0px 0px 8px 8px;\n}\n\n#logo-container #brand-logo {\n  max-width: 100%;\n  max-height: 100%;\n}\n/* Move to Theme */\n#proview_root .tvp-clr-white {\n  color: #fff;\n}\n#proview_root .tvp-clr-neutral {\n  color: var(--neutral-color);\n}\n#proview_root .tvp-clr-red {\n  color: #b91c1c;\n}\n#proview_root .tvp-brand-color {\n  color: var(--brand-color);\n}\n#proview_root .tvp-clr-green {\n  color: #1cb841;\n}\n\n#proview_root .tvp-clr-dgray {\n  color: #333;\n}\n\n#proview_root .tvp-bg-black {\n  background-color: #000 !important;\n}\n\n#proview_root .tvp-bg-white {\n  background-color: #fff;\n}\n\n#proview_root .tvp-bg-green {\n  background-color: var(--brand-color);\n}\n#proview_root .tvp-bg-red {\n  background-color: #d7554e;\n}\n\n#proview_root .tvp-bg-lgray {\n  background-color: #bdbdbd;\n  cursor: unset;\n}\n\n#proview_root .tvp-bg-lgray-500 {\n  background-color: #f7f0f0;\n}\n\n#proview_root .tvp-bdr-green {\n  border-color: var(--brand-color);\n}\n\n#proview_root .tvp-bdr-red {\n  border-color: #d7554e;\n}\n\n#proview_root .tvp-bdr-lgray {\n  border-color: #bdbdbd;\n}\n\n/* Customize classes */\n#proview_root .tvp-my-h-12 {\n  height: 48px;\n}\n\n#proview_root .tvp-base {\n  width: 96%;\n  max-height: 520px;\n  min-height: 520px;\n  border-top: 10px solid var(--brand-color);\n  min-width: 680px;\n}\n\n#proview_root .tvp-base .tvp-squre-25 {\n  width: 23px;\n  height: 23px;\n}\n\n#proview_root .tvp-base .tvp-DemoWrapper {\n  margin: -10px -15px;\n}\n\n#proview_root .tvp-base a:hover,\n#proview_root .tvp-base .tvp-link:hover {\n  color: #053a11 !important;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n#proview_root .tvp-base h2 {\n  font-size: 20px;\n}\n\n#proview_root .tvp-base h6 {\n  font-size: 18px;\n}\n\n#proview_root .tvp-base a,\n#proview_root .tvp-base .tvp-link {\n  color: var(--anchor-color) !important;\n  margin: 0px 5px;\n}\n\n#proview_root .tvp-base .tvp-miniLoader {\n  width: 40px;\n  height: 40px;\n  margin: auto;\n}\n\n#proview_root .tvp-base .tvp-screenShareIcon {\n  width: 220px;\n}\n\n#proview_root .tvp-base .tvp-iconHolder {\n  width: 35px;\n  cursor: pointer;\n  height: 35px;\n  background-color: #2dd4bf;\n  border-radius: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 15px;\n}\n\n#proview_root .tvp-base li {\n  position: relative;\n  min-height: 33px;\n  display: flex;\n}\n\n#proview_root .tvp-base .tvp-content {\n  align-items: center;\n}\n\n#proview_root .tvp-base .tvp-GlobeIcon {\n  display: block;\n  color: var(--neutral-color);\n}\n\n#proview_root .tvp-base .tvp-min-w-unset {\n  min-width: unset !important;\n}\n\n#proview_root .tvp-base .tvp-custom-file-input::-webkit-file-upload-button {\n  visibility: hidden;\n  z-index: 100;\n  width: 55%;\n}\n\n#proview_root #file_input {\n  min-height: 33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding-top: 3px;\n  max-width: 95px;\n  margin: auto;\n}\n\n#proview_root .tvp-base .tvp-custom-file-input::before {\n  content: \"Select Image\";\n  display: inline-block;\n  background: linear-gradient(to bottom, #f9f9f9, #e3e3e3);\n  border: 2px solid #1cb841 !important;\n  border-radius: 3px;\n  padding: 5px 8px;\n  outline: none;\n  white-space: nowrap;\n  cursor: pointer;\n  text-shadow: 1px 1px #fff;\n  font-weight: 700;\n  font-size: 10pt;\n  overflow: hidden;\n  z-index: 2;\n  height: 31px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n}\n\n/* Make label as display flex as important since conflicting with oliver styles */\n#proview_root .tvp-conditons label {\n  display: flex !important;\n}\n\n#proview_root .tvp-base .tvp-custom-file-input {\n  width: 60%;\n  overflow: hidden;\n  height: 33px;\n}\n\n#proview_root .tvp-base .tvp-custom-file-input:hover::before {\n  border-color: #000;\n}\n\n#proview_root .tvp-base .tvp-custom-file-input:active::before {\n  background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);\n}\n\n#proview_root .tvp-base .tvp-custom-file-input::before {\n  border-color: #000;\n  z-index: 11;\n}\n\n#proview_root .tvp-base .tvp-envCheckRecordingComplete {\n  width: 200px;\n  margin: 0 auto;\n  height: 150px;\n  background: #4a4a4a !important;\n  text-align: center;\n  line-height: 150px;\n  position: relative;\n}\n\n#proview_root .tvp-base .tvp-permissionIcon {\n  width: 130px;\n}\n\n#proview_root .tvp-base .tvp-IdPreview {\n  width: 200px;\n  height: 150px;\n  margin-left: auto;\n  margin-right: auto;\n  overflow: hidden;\n}\n\n#proview_root .tvp-base .tvp-w-55 {\n  width: 55%;\n}\n\n#proview_root .tvp-base .tvp-SmileyLogo {\n  width: 60%;\n  animation: wiggle 2s linear;\n}\n\n#proview_root .tvp-base .tvp-innerContent {\n  width: inherit;\n  height: inherit;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n#proview_root .tvp-base .tvp-photo-verification-page {\n  width: 45%;\n  text-align: center;\n  min-height: 200px;\n  height: 100%;\n}\n\n#proview_root .tvp-base .tvp-progressBarWrapper {\n  max-width: 400px;\n  width: 80vw;\n  background-color: #e0e0e0;\n  overflow: hidden;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px inset;\n  border-radius: 4px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n#proview_root .tvp-base .tvp-progressBar {\n  height: 20px;\n  background: linear-gradient(270deg, #eee 0%, #4caf50 9.31%, #4caf50 100%);\n  transition: width 0.6s ease;\n}\n\n#proview_root .tvp-base .tvp-or1-2 {\n  order: 1;\n}\n\n#proview_root .tvp-base .tvp-or2-1 {\n  order: 2;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n#proview_root .tvp-base .tvp-phto-text-folder {\n  max-height: 65px;\n  min-height: 65px;\n}\n\n#proview_root .tvp-base .tvp-divider-identity {\n  position: relative;\n  width: 4px;\n  min-height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: visible;\n  background-color: var(--brand-color);\n}\n\n#proview_root .tvp-base .tvp-dividerText-identity {\n  z-index: 999;\n  padding: 5px;\n  background-color: #fff;\n}\n\n#proview_root .tvp-base .tvp-mt-15 {\n  margin-top: 58px;\n}\n\n#proview_root .tvp-base .tvp-dropdown {\n  cursor: pointer;\n  max-width: 12em;\n  background: #fff;\n  color: rgba(0, 0, 0, 0.87);\n  border: 1px solid #bdbdbd;\n  border-radius: 5px !important;\n  padding: 5px;\n  font-size: 0.95em;\n  height: 34px;\n  text-overflow: ellipsis;\n  clear: both;\n}\n\n#proview_root .tvp-base .tvp-tips {\n  color: var(--neutral-color);\n  font-weight: 700;\n}\n\n#proview_root .tvp-base .tvp-videoPlayerWrapper {\n  width: fit-content;\n  height: 180px;\n}\n\n#proview_root .tvp-base .tvp-photIdVideoPlayerWrapper {\n  width: fit-content;\n  height: 150px;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n\n#proview_root .tvp-base .tvp-photoIdCanvas {\n  position: absolute;\n  top: 0;\n  /* left: 0; */\n}\n\n#proview_root .tvp-base .tvp-audioTest {\n  font-weight: normal;\n  text-transform: uppercase;\n  margin-bottom: 20px;\n  font-size: 0.8em;\n  color: var(--neutral-color);\n}\n\n#proview_root .tvp-base .tvp-testEnvDemoVideo {\n  width: 265px;\n  height: auto;\n  object-fit: contain !important;\n  margin: 0 auto;\n  border: 1px solid #ccc;\n}\n\n#proview_root .tvp-base .tvp-videoText {\n  min-width: 200px;\n  display: flex;\n  justify-content: center;\n  font-size: 14px;\n  align-items: center;\n  height: 33px;\n}\n\n#proview_root .tvp-base .tvp-parts {\n  width: 96%;\n  display: flex;\n  align-items: center;\n  padding: 5px 0px;\n  margin: 0px auto;\n}\n\n#proview_root .tvp-base .tvp-w-150 {\n  width: 150px !important;\n}\n\n#proview_root .tvp-base .tvp-min-w-150 {\n  min-width: 150px;\n}\n\n#proview_root .tvp-base .tvp-buttonPart {\n  width: fit-content;\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  justify-content: center;\n  margin: auto;\n  flex-direction: row;\n}\n\n#proview_root .tvp-base li {\n  padding: 5px;\n  display: flex;\n}\n\n#proview_root .tvp-base .tvp-recorderContainer {\n  position: absolute;\n  bottom: 17px;\n  left: 17px;\n  display: flex;\n  align-items: center;\n}\n\n#proview_root .tvp-base .tvp-screenShareIcon {\n  width: 228px;\n  height: 189px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n#proview_root .tvp-connectingIcon {\n  width: 120px;\n  height: 80px;\n}\n\n#proview_root .tvp-text-xs {\n  font-size: 12px !important;\n}\n\n#proview_root .tvp-proctoring_fc_frame {\n  margin-bottom: 100px;\n  z-index: 9999999 !important;\n  margin-right: 15px;\n}\n\n#proview_root .tvp-seccam-main {\n  width: 50%;\n  min-height: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 280px;\n  box-sizing: border-box;\n}\n\n#proview_root .tvp-seccam-Wrapper {\n  position: relative;\n  width: 100%;\n  min-height: 100%;\n  height: auto;\n  display: flex;\n  flex-grow: 1;\n  flex-direction: row;\n  flex-wrap: wrap;\n  overflow-y: auto;\n}\n\n#proview_root .tvp-demoBtn {\n  margin-right: 15px;\n}\n\n#proview_root #basediv {\n  background-color: #000;\n  min-width: 100vw;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n  max-height: 100vh;\n}\n\n#tvp_recorder_container {\n  position: relative;\n  z-index: 9999999;\n  width: 100%;\n  height: 100%;\n  display: flex;\n}\n\n#tvp_recorder_container_minimize_btn {\n  position: absolute;\n  z-index: 99999999;\n  cursor: pointer;\n  top: -10px;\n  right: -10px;\n  padding: 2px;\n  background-color: dodgerblue;\n  color: white;\n  width: 16px;\n  height: 16px;\n  display: grid;\n  place-items: center;\n  border: none;\n  border-radius: 50%;\n  pointer-events: auto;\n}\n\n#recorder_video_custom,\n#tvp_recorder_container {\n  z-index: 9999999;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 15.625vh;\n  height: 10.416vh;\n}\n\n#tvp_recorder_container > video,\n#tvp_recorder_container > canvas {\n  width: 15.625vh;\n  height: 10.416vh;\n}\n\n#tvp_recorder_container > video {\n  z-index: 300;\n  border: 3px solid #000;\n  border-radius: 6px;\n  background-color: #fff;\n}\n\n#tvp_recorder_container > canvas {\n  z-index: 400;\n}\n\n@media only screen and (max-width: 680px) {\n  #proview_root .tvp-base {\n    max-width: 94vw !important;\n    min-width: 94vw !important;\n    margin: auto !important;\n    margin: 2%;\n  }\n\n  #proview_root .tvp-my-h-12 {\n    height: auto !important;\n  }\n\n  #proview_root .tvp-base .tvp-phto-text-folder {\n    max-height: unset;\n    height: auto;\n  }\n\n  #proview_root .tvp-base .tvp-buttonPart {\n    width: 100%;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  #proview_root .tvp-base {\n    min-width: 94vw !important;\n    margin: auto !important;\n  }\n\n  #proview_root .tvp-base .tvp-app {\n    width: 98vw;\n  }\n\n  #proview_root .tvp-base .tvp-or1-2 {\n    order: 2;\n  }\n\n  #proview_root .tvp-base .tvp-videoText {\n    flex-direction: column;\n  }\n\n  #proview_root .tvp-base .tvp-or2-1 {\n    order: 1;\n  }\n\n  #proview_root .tvp-base .tvp-col-row {\n    display: flex;\n    flex-direction: column;\n  }\n\n  #proview_root .tvp-base .tvp-col-row > div {\n    width: 100% !important;\n  }\n\n  #proview_root .tvp-base .tvp-divider-identity {\n    position: relative;\n    width: 100%;\n    height: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: visible;\n    background-color: var(--brand-color);\n    margin-top: 7px;\n    margin-bottom: 7px;\n  }\n\n  #proview_root .tvp-base .tvp-progressBarWrapper {\n    max-width: 80%;\n  }\n\n  #proview_root .tvp-base .tvp-GlobeIcon {\n    display: none;\n  }\n\n  #proview_root .tvp-base .tvp-w-55 {\n    width: 100%;\n  }\n}\n\n@-moz-keyframes wiggle {\n  0%,\n  3% {\n    transform: rotateZ(0);\n  }\n\n  5% {\n    transform: rotateZ(-15deg);\n  }\n\n  10% {\n    transform: rotateZ(15deg);\n  }\n\n  16% {\n    transform: rotateZ(-12deg);\n  }\n\n  23% {\n    transform: rotateZ(12deg);\n  }\n\n  31% {\n    transform: rotateZ(-9deg);\n  }\n\n  40% {\n    transform: rotateZ(9deg);\n  }\n\n  50% {\n    transform: rotateZ(-6deg);\n  }\n\n  61% {\n    transform: rotateZ(6deg);\n  }\n\n  73% {\n    transform: rotateZ(-3deg);\n  }\n\n  87% {\n    transform: rotateZ(3deg);\n  }\n\n  97%,\n  100% {\n    transform: rotateZ(0);\n  }\n}\n\n@-webkit-keyframes wiggle {\n  0%,\n  3% {\n    transform: rotateZ(0);\n  }\n\n  5% {\n    transform: rotateZ(-15deg);\n  }\n\n  10% {\n    transform: rotateZ(15deg);\n  }\n\n  16% {\n    transform: rotateZ(-12deg);\n  }\n\n  23% {\n    transform: rotateZ(12deg);\n  }\n\n  31% {\n    transform: rotateZ(-9deg);\n  }\n\n  40% {\n    transform: rotateZ(9deg);\n  }\n\n  50% {\n    transform: rotateZ(-6deg);\n  }\n\n  61% {\n    transform: rotateZ(6deg);\n  }\n\n  73% {\n    transform: rotateZ(-3deg);\n  }\n\n  87% {\n    transform: rotateZ(3deg);\n  }\n\n  97%,\n  100% {\n    transform: rotateZ(0);\n  }\n}\n\n@-o-keyframes wiggle {\n  0%,\n  3% {\n    transform: rotateZ(0);\n  }\n\n  5% {\n    transform: rotateZ(-15deg);\n  }\n\n  10% {\n    transform: rotateZ(15deg);\n  }\n\n  16% {\n    transform: rotateZ(-12deg);\n  }\n\n  23% {\n    transform: rotateZ(12deg);\n  }\n\n  31% {\n    transform: rotateZ(-9deg);\n  }\n\n  40% {\n    transform: rotateZ(9deg);\n  }\n\n  50% {\n    transform: rotateZ(-6deg);\n  }\n\n  61% {\n    transform: rotateZ(6deg);\n  }\n\n  73% {\n    transform: rotateZ(-3deg);\n  }\n\n  87% {\n    transform: rotateZ(3deg);\n  }\n\n  97%,\n  100% {\n    transform: rotateZ(0);\n  }\n}\n\n@keyframes wiggle {\n  0%,\n  3% {\n    transform: rotateZ(0);\n  }\n\n  5% {\n    transform: rotateZ(-15deg);\n  }\n\n  10% {\n    transform: rotateZ(15deg);\n  }\n\n  16% {\n    transform: rotateZ(-12deg);\n  }\n\n  23% {\n    transform: rotateZ(12deg);\n  }\n\n  31% {\n    transform: rotateZ(-9deg);\n  }\n\n  40% {\n    transform: rotateZ(9deg);\n  }\n\n  50% {\n    transform: rotateZ(-6deg);\n  }\n\n  61% {\n    transform: rotateZ(6deg);\n  }\n\n  73% {\n    transform: rotateZ(-3deg);\n  }\n\n  87% {\n    transform: rotateZ(3deg);\n  }\n\n  97%,\n  100% {\n    transform: rotateZ(0);\n  }\n}\n\n.tvp-proview_root #tvp_recorder_holder .tvp-linkModel {\n  z-index: 1;\n  bottom: 40px;\n  left: 10px;\n  width: auto;\n  height: fit-content;\n  border: 1px solid #fff;\n  border-radius: 10px;\n  background-color: #f8fafc;\n  color: #1d4ed8;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15), 0px 0px 5px 0px rgba(0, 0, 0, 0.3);\n}\n\n.tvp-proview_root #tvp_recorder_holder .tvp-modalPosition {\n  left: 20px !important;\n  bottom: 32px !important;\n}\n\n.tvp-proview_root #tvp_recorder_holder .tvp-alignCenter {\n  align-items: center;\n}\n\n.tvp-proview_root #Dragablediv {\n  display: none;\n}\n\n.tvp-proview_root .tvp-button-no-border {\n  all: unset;\n  cursor: pointer;\n  border: none;\n  display: flex;\n  box-shadow: none;\n}\n\n.tvp-proview_root button.tvp-button-no-border:focus,\n.tvp-proview_root button.tvp-button-no-border:focus::before {\n  all: unset;\n  cursor: pointer;\n  border: none;\n  display: flex;\n  box-shadow: none;\n}\n\n/* #proview_root > div:nth-child(2){\n  display: none;\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
